import { IMenuHeader } from "../interfaces";
import { getRole, getOptimiseRoutesAccess } from "@/core/token";

const buildMenuHeaders = (): IMenuHeader => {
  const role = getRole();
  return {
    "/deliveries": { label: "DELIVERY ROUTES" },
    "/histories": { label: "HISTORY" },
    // "/reports": { label: "REPORTS" },
    ...(getOptimiseRoutesAccess() && {
      "/optimise-routes": { label: "OPTIMISE ROUTES" },
    }),
    ...(role === "Admin" && {
      "/settings": { label: "SETTINGS" },
    }),
  };
};

export default buildMenuHeaders;
